import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'hooks';
import { selectedAccountSelector } from '../../../selectors';
import { COMBINED_AUDIENCES_REPORT_ID } from '../../campaigns/modules/campaigns-reports/config/reports/combined-audience/combinedAudiencesReportId';
import { CUSTOM_CONTEXTUAL_REPORT_ID } from '../../campaigns/modules/campaigns-reports/config/reports/custom-contextual/customContextualReportId';
import { FIRST_PARTY_REPORT_ID } from '../../campaigns/modules/campaigns-reports/config/reports/first-party/firstPartyReportId';
import { PREDICTIVE_REPORT_ID } from '../../campaigns/modules/campaigns-reports/config/reports/lookalike/predictiveReportId';
import { PIXEL_BASED_REPORT_ID } from '../../campaigns/modules/campaigns-reports/config/reports/pixel-based/pixelBasedReportId';
import { AUDIENCE_TYPE } from '../config';
import {
    generateCombinedAudiencesEditorPath,
    generateCustomContextualEditorPath,
    generateFirstPartyEditorPath,
    generateMailDomainsEditorPath,
    generatePixelBasedEditorPath,
    generatePredictiveEditorPath,
    generateSearchKeywordsEditorPath,
} from '../utils/generateEditorPath';

const paths = {
    [PIXEL_BASED_REPORT_ID]: generatePixelBasedEditorPath,
    [FIRST_PARTY_REPORT_ID]: generateFirstPartyEditorPath,
    [PREDICTIVE_REPORT_ID]: generatePredictiveEditorPath,
    [CUSTOM_CONTEXTUAL_REPORT_ID]: generateCustomContextualEditorPath,
    [COMBINED_AUDIENCES_REPORT_ID]: generateCombinedAudiencesEditorPath,
    [AUDIENCE_TYPE.SEARCH_KEYWORDS]: generateSearchKeywordsEditorPath,
    [AUDIENCE_TYPE.MAIL_DOMAINS]: generateMailDomainsEditorPath,
};

const useOpenAudienceEditor = (reportType, audienceType) => {
    const { accountId: selectedAccountId } = useSelector(selectedAccountSelector);
    const navigate = useNavigate();

    const openAudienceEditor = useCallback(
        audience => {
            const { id, accountId } = audience;
            const resolvedAdvertiserName = accountId || selectedAccountId;
            const path =
                audienceType === AUDIENCE_TYPE.SEARCH_KEYWORDS || audienceType === AUDIENCE_TYPE.MAIL_DOMAINS
                    ? paths[audienceType]
                    : paths[reportType];
            const editAudiencePath = path({ accountId: resolvedAdvertiserName, audienceId: id });
            navigate(editAudiencePath);
        },
        [selectedAccountId, reportType, audienceType, navigate]
    );

    return openAudienceEditor;
};

export default useOpenAudienceEditor;
